import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'panel-filters';

/**
 * Class PanelFilter.
 */
export class PanelFilters extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  isOpen = false;

  connectedCallback() {
    this.openBtn = this.querySelector('.filter__btn');
    this.modal = this.querySelector('unistra-modal');

    this.openBtn.addEventListener('click', this.onOpenClick.bind(this));
  }

  onOpenClick() {
    this.modal.open();
  }
}

export default PanelFilters;
